<section>
	<main>
		<app-party-grid
			[option]="options"
			[mode]="mode"
			[dataType]="dataType"
			(appFormValue)="addParty($event)"
			[keyMapModel]="keyMapModel">
		</app-party-grid>
	</main>
</section>
